import { Stack } from "@mantine/core"
import {
  Row,
  Table as TanstackTable,
  ColumnDef,
  Column,
} from "@tanstack/react-table"
import { theme } from "@tfg/themes"
import { CSSProperties } from "react"

import { Checkbox } from "@tfg/ui"

export const CHECKBOX_COLUMN_ID = "select-col"
export const getCheckboxColumnDefs = <TData,>(): ColumnDef<TData> => {
  const checkboxColumnSize = theme.other.table.cells.checkbox
  return {
    id: CHECKBOX_COLUMN_ID,
    enablePinning: true,
    size: Number(theme.other.table.cells.checkbox),
    minSize: Number(theme.other.table.cells.checkbox),
    maxSize: Number(theme.other.table.cells.checkbox),
    header: ({ table }: { table: TanstackTable<TData> }) => (
      <Stack w={checkboxColumnSize / 2} p={0} align="center" justify="center">
        <Checkbox
          style={{ zIndex: 2, placeContent: "center" }}
          styles={{
            label: {
              display: "none",
            },
          }}
          size="xs"
          w="fit-content"
          checked={table.getIsAllPageRowsSelected()}
          indeterminate={
            table.getIsSomePageRowsSelected() &&
            !table.getIsAllPageRowsSelected()
          }
          onChange={table.getToggleAllPageRowsSelectedHandler()}
        />
      </Stack>
    ),
    cell: ({ row }: { row: Row<TData> }) => (
      <Stack w={checkboxColumnSize / 2} p={0} align="center" justify="center">
        <Checkbox
          onClick={(e) => {
            e.stopPropagation()
          }}
          size="xs"
          w="fit-content"
          style={{
            zIndex: 2,
          }}
          styles={{
            label: {
              display: "none",
            },
          }}
          checked={row.getIsSelected()}
          disabled={!row.getCanSelect()}
          onChange={row.getToggleSelectedHandler()}
        />
      </Stack>
    ),
  }
}

export const getCommonPinningStyles = <TData,>(
  column: Column<TData>
): CSSProperties => {
  const isPinned = column.getIsPinned()

  return {
    left:
      isPinned === PINNED_POSITIONS.LEFT
        ? `${column.getStart(PINNED_POSITIONS.LEFT)}px`
        : undefined,
    right:
      isPinned === PINNED_POSITIONS.RIGHT
        ? `${column.getAfter(PINNED_POSITIONS.RIGHT)}px`
        : undefined,
    position: isPinned ? "sticky" : "relative",
    width: column.getSize(),
    zIndex: isPinned ? 1 : 0,
  }
}

export const PINNED_POSITIONS = {
  LEFT: "left",
  RIGHT: "right",
} as const

export type PinnedPosition =
  (typeof PINNED_POSITIONS)[keyof typeof PINNED_POSITIONS]
